import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]
  static values = {
    delay: { type: Number, default: 150 }
  }

  connect () {
    this.closeTimeout = null
  }

  disconnect () {
    this.clearCloseTimeout()
  }

  open () {
    this.clearCloseTimeout()
    this.positionOverlay()
    this.element.classList.add("active")
  }

  close () {
    this.closeTimeout = setTimeout(() => {
      this.element.classList.remove("active")
    }, this.delayValue)
  }

  clearCloseTimeout () {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout)
      this.closeTimeout = null
    }
  }

  positionOverlay () {
    if (!this.hasOverlayTarget) return

    const header = document.querySelector(".header-desktop")
    if (header) {
      const headerRect = header.getBoundingClientRect()
      this.overlayTarget.style.top = `${headerRect.bottom}px`
    }
  }
}
